import React from "react";
import PropTypes from "prop-types";
import useMatchMedia from "~hooks/use_match_media/use_match_media";
import { BLOK_ARRAY } from "../../../prop_types";
import TOCNavDesktop from "./components/toc_nav_desktop/toc_nav_desktop";
import TOCNavMobile from "./components/toc_nav_mobile/toc_nav_mobile";

function TOCNav({
  activeItem,
  allChaptersTitle,
  chapters,
  collectionTitle,
  conversionType,
  currentChapterIndex,
  downloadButtonText,
  downloadFormDescription,
  downloadFormId,
  downloadFormTitle,
  isVisible,
  lang,
  pagePath,
  sections,
}) {
  const isMobileWindow = useMatchMedia({ max: "M" });

  if (!isMobileWindow) {
    return (
      <TOCNavDesktop
        activeItem={activeItem}
        allChaptersTitle={allChaptersTitle}
        chapters={chapters}
        collectionTitle={collectionTitle}
        conversionType={conversionType}
        currentChapterIndex={currentChapterIndex}
        downloadButtonText={downloadButtonText}
        downloadFormDescription={downloadFormDescription}
        downloadFormId={downloadFormId}
        downloadFormTitle={downloadFormTitle}
        isVisible={isVisible}
        lang={lang}
        pagePath={pagePath}
        sections={sections}
      />
    );
  }
  return (
    <TOCNavMobile
      activeItem={activeItem}
      allChaptersTitle={allChaptersTitle}
      chapters={chapters}
      collectionTitle={collectionTitle}
      conversionType={conversionType}
      currentChapterIndex={currentChapterIndex}
      downloadButtonText={downloadButtonText}
      downloadFormDescription={downloadFormDescription}
      downloadFormId={downloadFormId}
      downloadFormTitle={downloadFormTitle}
      lang={lang}
      pagePath={pagePath}
      sections={sections}
    />
  );
}

TOCNav.propTypes = {
  activeItem: PropTypes.string,
  allChaptersTitle: PropTypes.string,
  chapters: BLOK_ARRAY,
  collectionTitle: PropTypes.string,
  conversionType: PropTypes.string,
  currentChapterIndex: PropTypes.number,
  downloadButtonText: PropTypes.string,
  downloadFormDescription: PropTypes.string,
  downloadFormId: PropTypes.string,
  downloadFormTitle: PropTypes.string,
  isVisible: PropTypes.bool,
  lang: PropTypes.string,
  pagePath: PropTypes.string,
  sections: BLOK_ARRAY,
};

TOCNav.defaultProps = {
  activeItem: null,
  allChaptersTitle: "All chapters",
  chapters: null,
  collectionTitle: null,
  conversionType: "primary_conversion",
  currentChapterIndex: null,
  downloadButtonText: "Download the PDF",
  downloadFormDescription: "We just need a few details from you first",
  downloadFormId: null,
  downloadFormTitle: "Download the report",
  isVisible: false,
  lang: "en-gb",
  pagePath: null,
  sections: null,
};

export default TOCNav;
